import { render, staticRenderFns } from "./HeatMap.vue?vue&type=template&id=407c8a23"
import script from "./HeatMap.vue?vue&type=script&lang=js"
export * from "./HeatMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports